import { Injectable } from '@angular/core';
import { SlotCompactInfo } from '../models';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { SetInitialStateFacade } from '../../../../../common';
import { CompartmentRuleItem, HubBrief, HubContextFacade } from '../../../administration';
import {
  AllocationViewRuleBriefInitialState,
  AllocationViewRuleBriefLoad,
  AllocationViewRuleBriefSetCompartmentName,
  AllocationViewRuleBriefSetSlotCompactInfo,
} from './allocation-view-rule-brief.actions';
import { AllocationViewRuleBriefState } from './allocation-view-rule-brief.state';

@Injectable({ providedIn: 'root' })
export class AllocationViewRuleBriefFacade implements SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(AllocationViewRuleBriefState.getLoaded);
  rule$: Observable<CompartmentRuleItem> = this.store.select(AllocationViewRuleBriefState.getRule);
  hubId$: Observable<number> = this.store.select(AllocationViewRuleBriefState.getHubId);
  hubName$: Observable<string> = this.store.select(AllocationViewRuleBriefState.getHubName);
  compartmentId$: Observable<number> = this.store.select(AllocationViewRuleBriefState.getCompartmentId);
  compartmentName$: Observable<string> = this.store.select(AllocationViewRuleBriefState.getCompartmentName);
  slotCompactInfo$: Observable<SlotCompactInfo> = this.store.select(AllocationViewRuleBriefState.getSlotCompactInfo);

  constructor(private store: Store, private hubContextFacade: HubContextFacade) {}

  getRule(ruleId: number, compartmentId: number): void {
    this.hubContextFacade.selectedHub$.pipe(take(1)).subscribe((hub: HubBrief) => {
      this.store.dispatch(new AllocationViewRuleBriefLoad({ compartmentId, hub, ruleId }));
    });
  }

  setCompartmentName(compartmentName: string): void {
    this.store.dispatch(new AllocationViewRuleBriefSetCompartmentName({ compartmentName }));
  }

  setSlotCompactInfo(slotCompactInfo: SlotCompactInfo): void {
    this.store.dispatch(new AllocationViewRuleBriefSetSlotCompactInfo(slotCompactInfo));
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewRuleBriefInitialState());
  }
}
